import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import NavBar from './NavBar.vue';
import WebsiteFooter from './WebsiteFooter.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'WebsiteLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createBlock(_component_v_main, null, {
    default: _withCtx(() => [
      _createVNode(NavBar),
      _createVNode(_component_v_container, { class: "ma-0 pa-0 w-100 mw-100" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _: 3
      }),
      _createVNode(WebsiteFooter)
    ]),
    _: 3
  }))
}
}

})